import * as notificationsActionTypes from './types';
import * as notificationsActions from './actions';
import reducer from './reducer';

export {
  notificationsActionTypes,
  notificationsActions
};

export default reducer;